import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'map',
  pure: true
})
export class MapPipe implements PipeTransform {

  transform(array: any[], properties: string) {
    if (!array) return [];
    var p = properties.split(',');
    if(!p.length) return array;
    if (p.length == 1) 
      return array.map(_ => _[properties]);
    return array.map(_ => {
      var obj = {};
      p.filter(_ => _).forEach(p => obj[p] = _[p]);
      return obj;
    });
  }

}
